import {
  Button,
  Card,
  CardBody,
  Dialog,
  DialogBody,
  Menu,
  MenuHandler,
  MenuItem,
  MenuList,
} from "@material-tailwind/react";
import ExcelExport from "components/export";
import Input from "components/input";
import { IMAGE_URL } from "config";
import moment from "moment";
import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import { useFormik } from "formik";

/* PACKAGES */
import { Helmet } from "react-helmet";
import { IoClose } from "react-icons/io5";
import {
  deleteRSVPEntry,
  editRSVPList,
  getRSVPList,
  updateCompanions,
} from "service/api/contactUs.api";
import { GoKebabHorizontal } from "react-icons/go";
import toast from "react-hot-toast";

const options = [
  { value: null, label: "All categories" },
  {
    value: "Secondary School Scholars (Class 10)",
    label: "Secondary School Scholars (Class 10)",
  },
  {
    value: "Higher Secondary School Scholars (Class 12)",
    label: "Higher Secondary School Scholars (Class 12)",
  },
  { value: "Bachelors Program Toppers", label: "Bachelors Program Toppers" },
  { value: "Masters Program Toppers", label: "Masters Program Toppers" },
  {
    value: "University Gold Medalists",
    label: "University Gold Medalists",
  },
  {
    value: "Ph.D. Achievers",
    label: "Ph.D. Achievers",
  },
  {
    value: "Accountancy & Company Secretary Achievers (CA/CS/ICMA)",
    label: "Accountancy & Company Secretary Achievers (CA/CS/ICMA)",
  },
  {
    value: "Medical Degree Achievers (MBBS, MD, MS, DM, DNB, BDS, MDS)",
    label: "Medical Degree Achievers (MBBS, MD, MS, DM, DNB, BDS, MDS)",
  },
  {
    value: "Civil Services Achievers (UPSC/SPSC)",
    label: "Civil Services Achievers (UPSC/SPSC)",
  },
  {
    value: "Excellence in Teaching Profession",
    label: "Excellence in Teaching Profession",
  },
  {
    value: "Outstanding Educational Institutions",
    label: "Outstanding Educational Institutions",
  },
];

const RSVPList = () => {
  const [loading, setLoading] = useState(false);

  /* PAGE */
  const [page, setPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(10);

  /* TOTAL DOCS */
  const [totalDocs, setTotalDocs] = useState(0);

  /* LIST OF DATA */
  const [dataList, setDataList] = useState([]);

  /* DIALOG */
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedDetails, setSelectedDetails] = useState(null);

  /* DELETE DIALOG */
  const [deleteId, setDeleteId] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);

  /* EXPORT DATA */
  const [exportData, setExportData] = useState([]);

  /* SEARCH VALUE */
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(search);

  /* CATEGORY */
  const [category, setCategory] = useState(null);

  /* ADD COMPANIONS DIALOG */
  const [addCompanionDialog, setAddCompanionDialog] = useState(false);

  /* EDIT COMPANIONS DIALOG */
  const [editDetailsDialog, setEditDetailsDialog] = useState(false);

  /* FUNCTIONS */
  const handlePageChange = async (e) => {
    setPage(e);
  };

  /* HANDLE PER PAGE */
  const handlePerPageChange = async (e) => {
    setSizePerPage(e);
  };

  /* GET LIST OF DATA */
  const getData = () => {
    setLoading(true);

    const params = {
      page: page,
      sizePerPage: sizePerPage,
      pagination: true,
    };

    if (search !== "") {
      params.search = search;
    }

    if (category !== null) {
      params.awardCategory = category?.value;
    }

    getRSVPList(params)
      .then((res) => {
        setDataList(res?.data?.docs);
        setTotalDocs(res?.data?.totalDocs);
      })
      .catch((e) => {
        console.log("Error: ", e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  /* GET EXPORT LIST */
  const getExportList = () => {
    return new Promise((resolve, reject) => {
      setLoading(true);
      const params = {
        page: page,
        sizePerPage: 500,
        pagination: true,
      };

      getRSVPList(params)
        .then((res) => {
          let allData = res?.data?.docs || [];

          const tempArray = allData?.map((item, index) => {
            const companions = (item?.companions || []).reduce(
              (acc, r, idx) => {
                acc[
                  `Companion ${idx + 1} Name`
                ] = `${r.firstName} ${r.lastName}`;
                acc[`Companion ${idx + 1} Relation`] = r.relation;
                acc[`Companion ${idx + 1} Phone`] = r.phoneNumber;
                acc[`Companion ${idx + 1} Email`] = r.email;
                return acc;
              },
              {}
            );

            return {
              "Sr. No": index + 1,
              "Attending as": item?.attendingAs,
              Name: `${item?.firstName} ${item?.middleName} ${item?.lastName}`,
              Email: item?.email,
              Phone: item?.phoneNumber,
              "Mother's name": item?.mothersName,
              "Award Prize Amount cheque to be issued in favour of":
                item?.accountHolder,
              "Award category": item?.awardCategory,
              "Award rank": item?.awardRank ?? "-",
              "Award winner's profile": item?.description,
              Photograph: `https://storage.googleapis.com/kidsstreet-test/${item?.photograph}`,
              ...companions,
            };
          });

          setExportData(tempArray);
          resolve(tempArray);
        })
        .catch((e) => {
          console.error("Export data fetch error:", e);
          toast.error("Failed to fetch export data");
          reject(e);
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };

  /* LOADING SCREEN FOR DATATABLE */
  const LoadingScreen = () => {
    return (
      <div className="w-full bg-[#F5F5F5] bg-opacity-50 rounded-md border border-authBorder py-5">
        <p className="text-sm font-ibm-regular text-black text-center">
          Please wait!
        </p>
        <p className="text-sm font-ibm-regular text-black text-center">
          We are fetching data{" "}
        </p>
      </div>
    );
  };

  /* NO DATA SCREEN */
  const NoDataScreen = () => {
    return (
      <div className="w-full bg-[#F5F5F5] bg-opacity-50 rounded-md border border-authBorder py-5">
        <p className="text-sm font-ibm-regular text-black text-center">
          There are no students to display.
        </p>
      </div>
    );
  };

  /* COLUMNS */
  const columns = [
    {
      name: "Sr. No",
      grow: 0.5,
      selector: (row, index) => (
        <span className="text-sm font-ibm-regular text-black text-opacity-60">
          {index + 1}
        </span>
      ),
    },
    {
      name: "Attending as",
      grow: 0.8,
      selector: (row) => (
        <p className="text-sm font-ibm-regular text-black text-opacity-60">
          {row?.attendingAs}
        </p>
      ),
    },
    {
      name: "Awardee Name",
      grow: 1.5,
      selector: (row) => (
        <div className="flex flex-col py-2">
          <p className="text-sm font-ibm-semibold text-black">
            {row?.firstName} {row?.lastName}
          </p>
          <div className="mt-1">
            <a
              href={`mailto:${row.email}`}
              className="block text-sm text-blue-500 hover:underline"
            >
              {row.email}
            </a>
            <a
              href={`tel:${row.phoneNumber}`}
              className="mt-1 block text-sm text-blue-500 hover:underline"
            >
              {row.phoneNumber}
            </a>
          </div>
        </div>
      ),
    },
    {
      name: "Award Category",
      grow: 1.2,
      selector: (row) => (
        <p
          style={{ overflowWrap: "anywhere" }}
          className="text-sm font-ibm-semibold text-black"
        >
          {row.awardCategory}
        </p>
      ),
    },
    {
      name: "Award Rank",
      selector: (row) => (
        <p
          style={{ overflowWrap: "anywhere" }}
          className="text-sm font-ibm-regular text-greyText"
        >
          {row.awardRank === undefined ? "-" : row.awardRank}
        </p>
      ),
    },
    {
      name: "Date applied",
      selector: (row) => (
        <React.Fragment>
          <p
            style={{ overflowWrap: "anywhere" }}
            className="text-sm font-ibm-regular text-greyText pr-5"
          >
            {moment(row.createdAt).format("DD-MM-YYYY")}
          </p>
          <p
            style={{ overflowWrap: "anywhere" }}
            className="mt-1.5 text-sm font-ibm-regular text-greyText pr-5"
          >
            {moment(row.createdAt).format("HH:mm A")}
          </p>
        </React.Fragment>
      ),
    },
    {
      name: "Actions",
      selector: (row) => (
        <React.Fragment>
          <Menu>
            <MenuHandler>
              <Button className="shadow-none hover:shadow-none p-1.5 bg-greyBg border border-greyBorder hover:border-black/40 rounded-full transition-all duration-300 ease-in-out">
                <GoKebabHorizontal className="w-4 h-4 text-greyText rotate-90" />
              </Button>
            </MenuHandler>
            <MenuList className="p-1.5 min-w-[20vh] bg-white">
              <MenuItem
                onClick={() => {
                  setDialogOpen(!dialogOpen);
                  setSelectedDetails(row);
                }}
                className="text-sm font-ibm-regular px-4 py-2 text-black"
              >
                View details
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setEditDetailsDialog(!editDetailsDialog);
                  setSelectedDetails(row);
                }}
                className="text-sm font-ibm-regular px-4 py-2 text-black"
              >
                Edit details
              </MenuItem>
              {/* <MenuItem
                onClick={() => {
                  setAddCompanionDialog(!addCompanionDialog);
                  setDeleteId(row?._id);
                  setSelectedDetails(row);
                }}
                className="text-sm font-ibm-regular px-4 py-2 text-black"
              >
                Add companions
              </MenuItem> */}
              <MenuItem
                onClick={() => {
                  setDeleteId(row?._id);
                  setDeleteModal(!deleteModal);
                }}
                className="text-sm font-ibm-regular px-4 py-2 text-red-400"
              >
                Delete entry
              </MenuItem>
            </MenuList>
          </Menu>
        </React.Fragment>
      ),
    },
  ];

  useEffect(() => {
    getData();
  }, [page, sizePerPage, debouncedSearch, category]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [search]);

  /* HANDLE DELETE DATA */
  const handleDelete = () => {
    setLoading(true);
    deleteRSVPEntry(deleteId)
      .then((res) => {
        toast.success(res?.message || "Entry deleted successfully");
      })
      .catch((e) => {
        console.error("Error deleting application:", e);
        toast.error(
          e?.response?.data?.message || "Failed to delete application"
        );
      })
      .finally(() => {
        setDeleteModal(false);
        setDeleteId(null);
        setLoading(false);
        getData();
      });
  };

  const editFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      firstName: selectedDetails?.firstName || "",
      middleName: selectedDetails?.middleName || "",
      lastName: selectedDetails?.lastName || "",
      mothersName: selectedDetails?.mothersName || "",
      email: selectedDetails?.email || "",
      phoneNumber: selectedDetails?.phoneNumber || "",
      awardCategory: selectedDetails?.awardCategory || "",
      awardRank: selectedDetails?.awardRank || "",
      description: selectedDetails?.description || "",
      accountHolder: selectedDetails?.accountHolder || "",
      companions:
        selectedDetails?.companions?.map(({ _id, ...rest }) => ({ ...rest })) ||
        [],
    },
    onSubmit: (values) => {
      setLoading(true);

      const payload = {
        attendingAs: selectedDetails?.attendingAs,
        firstName: values?.firstName,
        middleName: values?.middleName,
        photograph: selectedDetails?.photograph,
        lastName: values?.lastName,
        mothersName: values?.mothersName,
        email: values?.email,
        phoneNumber: values?.phoneNumber,
        awardCategory: values?.awardCategory,
        awardRank: values?.awardRank === "" ? "-" : values?.awardRank,
        description: values?.description,
        accountHolder: values?.accountHolder,
      };

      const cleanValues = {
        ...payload,
        companions: values.companions.map(({ _id, ...rest }) => rest),
      };

      editRSVPList(selectedDetails?._id, cleanValues)
        .then((res) => {
          toast.success(res?.message || "Entry updated successfully");
        })
        .catch((e) => {
          console.error("Error updating application:", e);
          toast.error(
            e?.response?.data?.message || "Failed to update application"
          );
        })
        .finally(() => {
          setEditDetailsDialog(false);
          setLoading(false);
          getData();
        });
    },
  });

  return (
    <section className="min-h-screen xl:min-h-full lg:min-h-full">
      {/* PAGE TITLE */}
      <Helmet>
        <title>RSVP List | Admin Panel</title>
      </Helmet>

      <div className="container-full-width">
        {/* HEADING */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between">
          <div className="p-0">
            <h1 className="text-2xl font-ibm-bold text-black tracking-tight">
              RSVP List
            </h1>
            <h2 className="text-base font-ibm-regular text-greyText">
              Manage and view the rsvp list of your event
            </h2>
          </div>

          {/* EXCEL EXPORT BUTTON */}
          <div className="flex items-center gap-5">
            {/* FILTER BY CATEGORY */}
            <div className="w-full md:w-[200px]">
              <Select
                options={options}
                className="react-select"
                classNamePrefix="dropdown"
                value={category}
                onChange={(e) => setCategory(e)}
                placeholder="Filter by award category"
              />
            </div>
            <div className="w-full md:w-[250px]">
              <Input
                type="text"
                placeholder="Search by name, email or phone"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="w-full"
              />
            </div>
            <ExcelExport
              data={exportData}
              fileName="RSVP List"
              btnText="Export data"
              onClickFn={async () => {
                try {
                  return await getExportList();
                } catch (error) {
                  console.error("Failed to prepare export data:", error);
                  throw error;
                }
              }}
            />
          </div>
        </div>

        {/* DATA TABLE */}
        <div className="mt-5">
          <Card className="bg-white border border-greyBorder rounded-lg">
            <CardBody className="p-5">
              <DataTable
                columns={columns}
                data={dataList}
                progressPending={loading}
                progressComponent={<LoadingScreen />}
                noDataComponent={<NoDataScreen />}
                pagination
                paginationServer
                paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 50, 100]}
                paginationTotalRows={totalDocs}
                onChangeRowsPerPage={handlePerPageChange}
                onChangePage={handlePageChange}
                className="data-table"
              />
            </CardBody>
          </Card>
        </div>
      </div>

      {/* VIEW DETAILS DIALOG */}
      <Dialog
        open={dialogOpen}
        handler={() => setDialogOpen(!dialogOpen)}
        size="sm"
      >
        <DialogBody className="p-0 max-h-[80vh] overflow-auto">
          {/* HEADING */}
          <div className="px-5 py-2.5 border-b border-[#E5E5E5] flex items-center justify-between">
            <h5 className="text-base font-ibm-semibold text-black">
              Companion details
            </h5>
            <button
              onClick={() => setDialogOpen(!dialogOpen)}
              className="shadow-none p-2 rounded-full bg-white hover:bg-black/5 transition-all duration-200 ease-in-out"
            >
              <IoClose className="w-5 h-5 text-[#777]" />
            </button>
          </div>

          {/* BODY */}
          <div className="p-5">
            {/* PHOTOGRAPH */}
            <div className="p-0">
              <label className="text-sm font-ibm-regular text-black">
                Photograph
              </label>
              <div className="mt-1">
                <img
                  src={`${IMAGE_URL}${selectedDetails?.photograph}`}
                  className="w-32 h-32 rounded-md object-cover object-top"
                  alt="Profile"
                />
              </div>
            </div>

            {/* NAME */}
            <div className="mt-5 grid grid-cols-3 gap-5">
              <div className="col-span-1">
                <label className="text-sm font-ibm-regular text-black">
                  First Name
                </label>
                <div className="mt-1">
                  <div className="px-4 py-3 border border-greyBorder rounded-lg shadow">
                    <p className="text-sm font-ibm-semibold text-black">
                      {selectedDetails?.firstName}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-span-1">
                <label className="text-sm font-ibm-regular text-black">
                  Middle Name
                </label>
                <div className="mt-1">
                  <div className="px-4 py-3 border border-greyBorder rounded-lg shadow">
                    <p className="text-sm font-ibm-semibold text-black">
                      {selectedDetails?.middleName}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-span-1">
                <label className="text-sm font-ibm-regular text-black">
                  Last Name
                </label>
                <div className="mt-1">
                  <div className="px-4 py-3 border border-greyBorder rounded-lg shadow">
                    <p className="text-sm font-ibm-semibold text-black">
                      {selectedDetails?.lastName}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* MOTHER's NAME */}
            <div className="mt-5">
              {selectedDetails?.awardCategory ===
              "Outstanding Educational Institutions" ? (
                <label className="text-sm font-ibm-regular text-black">
                  Name of the awardee institution
                </label>
              ) : (
                <label className="text-sm font-ibm-regular text-black">
                  Mother's name
                </label>
              )}

              <div className="mt-1">
                <div className="px-4 py-3 border border-greyBorder rounded-lg shadow">
                  <p className="text-sm font-ibm-semibold text-black">
                    {selectedDetails?.mothersName}
                  </p>
                </div>
              </div>
            </div>

            {/* PASSBOOK NAME  */}
            <div className="mt-5">
              <label className="text-sm font-ibm-regular text-black">
                Award Prize Amount cheque to be issued in favour of
              </label>
              <div className="mt-1">
                <div className="px-4 py-3 border border-greyBorder rounded-lg shadow">
                  <p className="text-sm font-ibm-semibold text-black">
                    {selectedDetails?.accountHolder}
                  </p>
                </div>
              </div>
            </div>

            {/* EMAIL AND PHONE */}
            <div className="mt-5 grid grid-cols-2 gap-5">
              <div className="col-span-1">
                <label className="text-sm font-ibm-regular text-black">
                  Email
                </label>
                <div className="mt-1">
                  <div className="px-4 py-3 border border-greyBorder rounded-lg shadow">
                    <p className="text-sm font-ibm-semibold text-black">
                      {selectedDetails?.email}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-span-1">
                <label className="text-sm font-ibm-regular text-black">
                  Phone
                </label>
                <div className="mt-1">
                  <div className="px-4 py-3 border border-greyBorder rounded-lg shadow">
                    <p className="text-sm font-ibm-semibold text-black">
                      {selectedDetails?.phoneNumber}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* AWARD CATEGORY AND RANK */}
            <div className="mt-5 grid grid-cols-2 gap-5">
              <div className="col-span-1">
                <label className="text-sm font-ibm-regular text-black">
                  Award Category
                </label>
                <div className="mt-1">
                  <div className="px-4 py-3 border border-greyBorder rounded-lg shadow">
                    <p className="text-sm font-ibm-semibold text-black">
                      {selectedDetails?.awardCategory}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-span-1">
                <label className="text-sm font-ibm-regular text-black">
                  Rank
                </label>
                <div className="mt-1">
                  <div className="px-4 py-3 border border-greyBorder rounded-lg shadow">
                    <p className="text-sm font-ibm-semibold text-black">
                      {selectedDetails?.awardRank === undefined
                        ? "Not applicable"
                        : selectedDetails?.awardRank}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* PROFILE */}
            <div className="mt-5">
              <label className="text-sm font-ibm-regular text-black">
                Award Winner's Profile
              </label>
              <div className="mt-1">
                <div className="px-4 py-3 border border-greyBorder rounded-lg shadow">
                  <p className="text-sm font-ibm-semibold text-black">
                    {selectedDetails?.description}
                  </p>
                </div>
              </div>
            </div>

            {/* COMPANIONS */}
            {selectedDetails?.companions?.length > 0 && (
              <div className="mt-5">
                <h5 className="text-base font-ibm-bold text-black">
                  Companions
                </h5>
                <div className="mt-2 grid grid-cols-2 gap-5">
                  {selectedDetails?.companions?.map((companion, index) => (
                    <div key={index} className="col-span-1">
                      <div className="bg-white border border-[#E5E5E5] rounded-lg shadow p-5">
                        <p className="text-sm font-ibm-semibold text-black">
                          {companion?.firstName} {companion?.lastName} (
                          {companion?.relation})
                        </p>
                        <div className="mt-1">
                          <a
                            href={`mailto:${companion.email}`}
                            className="block text-sm text-blue-500 hover:underline font-ibm-regular"
                          >
                            {companion.email}
                          </a>
                          <a
                            href={`tel:${companion.phoneNumber}`}
                            className="mt-1 block text-sm text-blue-500 hover:underline font-ibm-regular"
                          >
                            {companion.phoneNumber}
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </DialogBody>
      </Dialog>

      {/* DELETE MODAL */}
      <Dialog
        open={deleteModal}
        handler={() => setDeleteModal(!deleteModal)}
        size="xs"
      >
        <DialogBody className="p-0">
          {/* HEADING */}
          <div className="px-5 py-3 border-b border-greyBorder">
            <div className="flex items-center justify-between">
              <h5 className="text-base font-ibm-semibold text-black">
                Delete entry
              </h5>
              <Button
                onClick={() => setDeleteModal(!deleteModal)}
                className="p-2 rounded-full shadow-none hover:shadow-none bg-transparent hover:bg-black hover:bg-opacity-5"
              >
                <IoClose className="w-5 h-5 text-black" />
              </Button>
            </div>
          </div>

          {/* BODY */}
          <div className="p-5">
            <p className="text-sm font-ibm-regular text-black">
              Are you sure you want to delete this rsvp entry? This action
              cannot be undone.
            </p>
            <div className="flex items-center justify-end gap-2 mt-5">
              <Button
                onClick={() => setDeleteModal(!deleteModal)}
                className="py-2 px-4 rounded-md shadow-none hover:shadow-none bg-transparent hover:bg-black hover:bg-opacity-5 text-sm font-ibm-regular text-black"
              >
                Cancel
              </Button>
              <Button
                onClick={handleDelete}
                className="py-2 px-4 rounded-md shadow-none hover:shadow-none bg-red-500 hover:bg-red-600 text-sm font-ibm-regular text-white"
              >
                {loading ? "Deleting entry..." : "Delete entry"}
              </Button>
            </div>
          </div>
        </DialogBody>
      </Dialog>

      {/* ADD COMPANIONS DIALOG */}
      <Dialog
        open={addCompanionDialog}
        handler={() => setAddCompanionDialog(!addCompanionDialog)}
        size="sm"
      >
        <DialogBody className="p-0">
          {/* HEADING */}
          <div className="px-5 py-3 border-b border-greyBorder flex items-center justify-between">
            <h5 className="text-base font-ibm-semibold text-black">
              Add companions
            </h5>
            <Button
              onClick={() => setAddCompanionDialog(!addCompanionDialog)}
              className="shadow-none hover:shadow-none bg-white hover:bg-black/10 rounded-full p-1 transition-all duration-300 ease-in-out"
            >
              <IoClose className="w-5 h-5 text-greyText" />
            </Button>
          </div>

          {/* BODY */}
          <div className="p-5 max-h-[70vh] overflow-auto">
            {(() => {
              const formik = useFormik({
                initialValues: {
                  companions: [
                    {
                      firstName: "",
                      lastName: "",
                      relation: "",
                      email: "",
                      phoneNumber: "",
                    },
                  ],
                },
                onSubmit: async (values) => {
                  const {
                    _id,
                    __v,
                    isActive,
                    createdAt,
                    updatedAt,
                    isDeleted,
                    addedBy,
                    ...rest
                  } = selectedDetails;

                  const payload = {
                    ...rest,
                    companions: [...rest.companions, ...values.companions],
                  };

                  try {
                    await editRSVPList(deleteId, payload);
                    toast.success("Companions added successfully");
                  } catch (e) {
                    console.log("Error: ", e);
                  } finally {
                    setAddCompanionDialog(!addCompanionDialog);
                    formik.setFieldValue("companions", [
                      {
                        firstName: "",
                        lastName: "",
                        relation: "",
                        email: "",
                        phoneNumber: "",
                      },
                    ]);
                    getData();
                  }
                },
              });

              const handleAddCompanion = () => {
                formik.setFieldValue("companions", [
                  ...formik.values.companions,
                  {
                    firstName: "",
                    lastName: "",
                    relation: "",
                    email: "",
                    phoneNumber: "",
                  },
                ]);
              };

              const handleRemoveCompanion = (index) => {
                const updated = [...formik.values.companions];
                updated.splice(index, 1);
                formik.setFieldValue("companions", updated);
              };

              return (
                <form onSubmit={formik.handleSubmit}>
                  {formik.values.companions.map((companion, index) => (
                    <div
                      key={index}
                      className="mb-5 border border-gray-200 rounded-lg p-4 relative"
                    >
                      {/* REMOVE BUTTON */}
                      {formik.values.companions.length > 1 && (
                        <button
                          type="button"
                          onClick={() => handleRemoveCompanion(index)}
                          className="absolute top-2 right-2 text-red-500 text-sm font-ibm-semibold"
                        >
                          Remove
                        </button>
                      )}

                      {/* FIRST NAME + LAST NAME */}
                      <div className="grid grid-cols-2 gap-5">
                        <div>
                          <label className="text-sm font-ibm-regular text-greyText">
                            First name
                          </label>
                          <input
                            type="text"
                            name={`companions[${index}].firstName`}
                            value={companion.firstName}
                            onChange={formik.handleChange}
                            className="block w-full px-4 py-2 rounded-md text-black border border-authBorder text-sm mt-1 font-ibm-regular"
                            placeholder="First name"
                          />
                        </div>
                        <div>
                          <label className="text-sm font-ibm-regular text-greyText">
                            Last name
                          </label>
                          <input
                            type="text"
                            name={`companions[${index}].lastName`}
                            value={companion.lastName}
                            onChange={formik.handleChange}
                            className="block w-full px-4 py-2 rounded-md text-black border border-authBorder text-sm mt-1 font-ibm-regular"
                            placeholder="Last name"
                          />
                        </div>
                      </div>

                      {/* RELATION */}
                      <div className="mt-5">
                        <label className="text-sm font-ibm-regular text-greyText">
                          Relation with awardee
                        </label>
                        <Select
                          options={[
                            { value: "Father", label: "Father" },
                            { value: "Mother", label: "Mother" },
                            { value: "Guardian", label: "Guardian" },
                            { value: "Sibling", label: "Sibling" },
                            { value: "Child", label: "Child" },
                            {
                              value: "Partner/Spouse",
                              label: "Partner/Spouse",
                            },
                            {
                              value: "Chairman/President/CEO/Director",
                              label: "Chairman/President/CEO/Director",
                            },
                            {
                              value: "Trustee/Managing Committee Member",
                              label: "Trustee/Managing Committee Member",
                            },
                          ]}
                          className="react-select mt-1"
                          classNamePrefix="dropdown"
                          placeholder="Select relation"
                          value={
                            companion.relation
                              ? {
                                  value: companion.relation,
                                  label: companion.relation,
                                }
                              : null
                          }
                          onChange={(selected) =>
                            formik.setFieldValue(
                              `companions[${index}].relation`,
                              selected?.value || ""
                            )
                          }
                        />
                      </div>

                      {/* EMAIL + PHONE */}
                      <div className="mt-5 grid grid-cols-2 gap-5">
                        <div>
                          <label className="text-sm font-ibm-regular text-greyText">
                            Email
                          </label>
                          <input
                            type="email"
                            name={`companions[${index}].email`}
                            value={companion.email}
                            onChange={formik.handleChange}
                            className="block w-full px-4 py-2 rounded-md text-black border border-authBorder text-sm mt-1 font-ibm-regular"
                            placeholder="Email address"
                          />
                        </div>
                        <div>
                          <label className="text-sm font-ibm-regular text-greyText">
                            Phone
                          </label>
                          <div className="relative mt-1">
                            <span className="absolute top-[1vh] left-3 text-sm text-black font-ibm-regular">
                              +91
                            </span>
                            <input
                              type="text"
                              name={`companions[${index}].phoneNumber`}
                              value={companion.phoneNumber}
                              onChange={formik.handleChange}
                              className="block w-full pl-12 pr-4 py-2 text-black rounded-md border border-authBorder text-sm font-ibm-regular"
                              placeholder="Phone number"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}

                  {/* SUBMIT */}
                  <div className="mt-5 flex justify-between">
                    {/* ADD MORE BUTTON */}
                    <Button
                      type="button"
                      onClick={handleAddCompanion}
                      className="shadow-none hover:shadow-none px-5 py-2 text-[#EF4444] text-sm font-ibm-regular bg-[#EF4444]/10 rounded-md hover:bg-[#EF4444]/20 transition-all duration-300 ease-in-out"
                    >
                      Add companion
                    </Button>
                    <Button
                      type="submit"
                      className="shadow-none hover:shadow-none px-5 py-2 text-white text-sm font-ibm-regular bg-[#EF4444] rounded-md hover:bg-[#EF4444]/80 transition-all duration-300 ease-in-out"
                    >
                      Save Companions
                    </Button>
                  </div>
                </form>
              );
            })()}
          </div>
        </DialogBody>
      </Dialog>

      {/* EDIT COMPANIONS DIALOG */}
      <Dialog
        open={editDetailsDialog}
        handler={() => setEditDetailsDialog(!editDetailsDialog)}
        size="md"
      >
        <DialogBody className="p-0">
          {/* HEADING */}
          <div className="px-5 py-3 border-b border-greyBorder flex items-center justify-between">
            <h5 className="text-base font-ibm-semibold text-black">
              Edit details
            </h5>
            <Button
              onClick={() => setEditDetailsDialog(!editDetailsDialog)}
              className="shadow-none hover:shadow-none bg-white hover:bg-black/10 rounded-full p-1 transition-all duration-300 ease-in-out"
            >
              <IoClose className="w-5 h-5 text-greyText" />
            </Button>
          </div>

          {/* BODY */}
          <form
            onSubmit={editFormik.handleSubmit}
            className="p-5 space-y-5 max-h-[70vh] overflow-auto"
          >
            {/* AWARD CATEGORY + RANK */}
            <div
              className={`${
                editFormik.values.awardCategory ===
                  "Secondary School Scholars (Class 10)" ||
                editFormik.values.awardCategory ===
                  "Higher Secondary School Scholars (Class 12)"
                  ? "grid grid-cols-2 gap-5"
                  : "grid grid-cols-1 gap-5"
              }`}
            >
              <div>
                <label className="text-sm font-ibm-regular text-greyText">
                  Award category
                </label>
                <input
                  type="text"
                  name="awardCategory"
                  disabled
                  value={editFormik.values.awardCategory}
                  onChange={editFormik.handleChange}
                  className="block w-full px-4 py-2 border border-authBorder rounded-md text-sm font-ibm-regular text-black"
                />
              </div>
              <div
                className={`${
                  editFormik.values.awardCategory ===
                    "Secondary School Scholars (Class 10)" ||
                  editFormik.values.awardCategory ===
                    "Higher Secondary School Scholars (Class 12)"
                    ? "block"
                    : "hidden"
                }`}
              >
                <label className="text-sm font-ibm-regular text-greyText">
                  Award rank
                </label>
                <input
                  type="text"
                  name="awardRank"
                  value={editFormik.values.awardRank}
                  onChange={editFormik.handleChange}
                  className="block w-full px-4 py-2 border border-authBorder rounded-md text-sm font-ibm-regular text-black"
                />
              </div>
            </div>

            {/* FIRST, MIDDLE, LAST NAME */}
            <div className="grid grid-cols-3 gap-5">
              <div>
                <label className="text-sm font-ibm-regular text-greyText">
                  First name <span className="text-red-400">*</span>
                </label>
                <input
                  type="text"
                  name="firstName"
                  value={editFormik.values.firstName}
                  onChange={editFormik.handleChange}
                  className="block w-full px-4 py-2 border border-authBorder rounded-md text-sm font-ibm-regular text-black"
                />
              </div>
              <div>
                <label className="text-sm font-ibm-regular text-greyText">
                  Middle name
                </label>
                <input
                  type="text"
                  name="middleName"
                  value={editFormik.values.middleName}
                  onChange={editFormik.handleChange}
                  className="block w-full px-4 py-2 border border-authBorder rounded-md text-sm font-ibm-regular text-black"
                />
              </div>
              <div>
                <label className="text-sm font-ibm-regular text-greyText">
                  Last name
                </label>
                <input
                  type="text"
                  name="lastName"
                  value={editFormik.values.lastName}
                  onChange={editFormik.handleChange}
                  className="block w-full px-4 py-2 border border-authBorder rounded-md text-sm font-ibm-regular text-black"
                />
              </div>
            </div>

            {/* EMAIL + PHONE */}
            <div className="grid grid-cols-2 gap-5">
              <div>
                <label className="text-sm font-ibm-regular text-greyText">
                  Awardee Email ID
                </label>
                <input
                  type="email"
                  name="email"
                  value={editFormik.values.email}
                  onChange={editFormik.handleChange}
                  className="block w-full px-4 py-2 border border-authBorder rounded-md text-sm font-ibm-regular text-black"
                />
              </div>
              <div>
                <label className="text-sm font-ibm-regular text-greyText">
                  Mobile Number
                </label>
                <input
                  type="text"
                  name="phoneNumber"
                  value={editFormik.values.phoneNumber}
                  onChange={editFormik.handleChange}
                  className="block w-full px-4 py-2 border border-authBorder rounded-md text-sm font-ibm-regular text-black"
                />
              </div>
            </div>

            {/* MOTHER'S NAME / INSTITUTION NAME */}
            <div>
              <label className="text-sm font-ibm-regular text-greyText">
                {editFormik.values.awardCategory ===
                "Outstanding Educational Institutions"
                  ? "Name of the awardee institution"
                  : "Mother's name"}
              </label>
              <input
                type="text"
                name="mothersName"
                value={editFormik.values.mothersName}
                onChange={editFormik.handleChange}
                className="block w-full px-4 py-2 border border-authBorder rounded-md text-sm font-ibm-regular text-black"
              />
            </div>

            {/* DESCRIPTION */}
            <div>
              <label className="text-sm font-ibm-regular text-greyText">
                Award winner's profile
              </label>
              <textarea
                name="description"
                value={editFormik.values.description}
                onChange={editFormik.handleChange}
                className="block w-full px-4 py-2 border border-authBorder rounded-md text-sm font-ibm-regular text-black"
                rows="4"
              />
            </div>

            {/* ACCOUNT HOLDER */}
            <div>
              <label className="text-sm font-ibm-regular text-greyText">
                Award Prize Amount cheque to be issued in favour of
              </label>
              <input
                type="text"
                name="accountHolder"
                value={editFormik.values.accountHolder}
                onChange={editFormik.handleChange}
                className="block w-full px-4 py-2 border border-authBorder rounded-md text-sm font-ibm-regular text-black"
              />
            </div>

            {editFormik.values.companions.length > 0 && (
              <div className="mt-5">
                <h5 className="text-base font-ibm-bold text-black">
                  Companions
                </h5>
                <div className="mt-3 space-y-4">
                  {editFormik.values.companions.map((companion, index) => (
                    <div
                      key={index}
                      className="p-4 border border-gray-200 rounded-lg relative"
                    >
                      {/* REMOVE BUTTON */}
                      {editFormik.values.companions.length > 1 && (
                        <button
                          type="button"
                          onClick={() => {
                            const updated = [...editFormik.values.companions];
                            updated.splice(index, 1);
                            editFormik.setFieldValue("companions", updated);
                          }}
                          className="absolute top-2 right-2 text-red-500 text-sm font-ibm-semibold"
                        >
                          Remove
                        </button>
                      )}

                      {/* FIRST + LAST NAME */}
                      <div className="grid grid-cols-2 gap-5">
                        <div>
                          <label className="text-sm font-ibm-regular text-greyText">
                            First name
                          </label>
                          <input
                            type="text"
                            name={`companions[${index}].firstName`}
                            value={companion.firstName}
                            onChange={editFormik.handleChange}
                            className="w-full px-3 py-2 border rounded-md text-sm font-ibm-regular text-black"
                          />
                        </div>
                        <div>
                          <label className="text-sm font-ibm-regular text-greyText">
                            Last name
                          </label>
                          <input
                            type="text"
                            name={`companions[${index}].lastName`}
                            value={companion.lastName}
                            onChange={editFormik.handleChange}
                            className="w-full px-3 py-2 border rounded-md text-sm font-ibm-regular text-black"
                          />
                        </div>
                      </div>

                      {/* EMAIL + PHONE */}
                      <div className="mt-4 grid grid-cols-3 gap-5">
                        <div className="col-span-1">
                          <label className="text-sm font-ibm-regular text-greyText">
                            Relation
                          </label>
                          <Select
                            options={[
                              { value: "Father", label: "Father" },
                              { value: "Mother", label: "Mother" },
                              { value: "Guardian", label: "Guardian" },
                              { value: "Sibling", label: "Sibling" },
                              { value: "Child", label: "Child" },
                              {
                                value: "Partner/Spouse",
                                label: "Partner/Spouse",
                              },
                              {
                                value: "Chairman/President/CEO/Director",
                                label: "Chairman/President/CEO/Director",
                              },
                              {
                                value: "Trustee/Managing Committee Member",
                                label: "Trustee/Managing Committee Member",
                              },
                            ]}
                            className="react-select mt-1"
                            classNamePrefix="dropdown"
                            placeholder="Select relation"
                            value={
                              companion.relation
                                ? {
                                    value: companion.relation,
                                    label: companion.relation,
                                  }
                                : null
                            }
                            onChange={(selected) =>
                              editFormik.setFieldValue(
                                `companions[${index}].relation`,
                                selected?.value || ""
                              )
                            }
                          />
                        </div>
                        <div className="col-span-1">
                          <label className="text-sm font-ibm-regular text-greyText">
                            Email
                          </label>
                          <input
                            type="email"
                            name={`companions[${index}].email`}
                            value={companion.email}
                            onChange={editFormik.handleChange}
                            className="w-full px-3 py-2 border rounded-md text-sm font-ibm-regular text-black"
                          />
                        </div>
                        <div className="col-span-1">
                          <label className="text-sm font-ibm-regular text-greyText">
                            Phone
                          </label>
                          <input
                            type="text"
                            name={`companions[${index}].phoneNumber`}
                            value={companion.phoneNumber}
                            onChange={editFormik.handleChange}
                            className="w-full px-3 py-2 border rounded-md text-sm font-ibm-regular text-black"
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* ADD COMPANION BUTTON */}
            <Button
              type="button"
              onClick={() =>
                editFormik.setFieldValue("companions", [
                  ...editFormik.values.companions,
                  {
                    firstName: "",
                    lastName: "",
                    relation: "",
                    email: "",
                    phoneNumber: "",
                  },
                ])
              }
              className="shadow-none hover:shadow-none px-4 py-2 text-sm text-[#EF4444] bg-[#EF4444]/10 rounded-md font-ibm-semibold"
            >
              Add Companion
            </Button>

            {/* FOOTER BUTTONS */}
            <div className="flex justify-end gap-3 pt-4">
              <Button
                type="button"
                onClick={() => setEditDetailsDialog(false)}
                className="shadow-none hover:shadow-none font-ibm-semibold px-4 py-2 bg-gray-200 text-black rounded-md hover:bg-gray-300 text-sm"
              >
                Cancel
              </Button>
              <Button
                type="submit"
                disabled={loading}
                className="shadow-none hover:shadow-none font-ibm-semibold px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 text-sm"
              >
                {loading ? "Saving..." : "Save changes"}
              </Button>
            </div>
          </form>
        </DialogBody>
      </Dialog>
    </section>
  );
};

export default RSVPList;
